import { render, staticRenderFns } from "./VDetailsForm.vue?vue&type=template&id=46415006"
import script from "./VDetailsForm.vue?vue&type=script&lang=js"
export * from "./VDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports